import { render, staticRenderFns } from "./SupplierManufacturingAllergens.vue?vue&type=template&id=fe796998&scoped=true"
import script from "./SupplierManufacturingAllergens.vue?vue&type=script&lang=js"
export * from "./SupplierManufacturingAllergens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe796998",
  null
  
)

export default component.exports